import type { TypeFormElementOrList } from '../../../types/form';
import { validateForm, type TypeDataConfig } from '../result';

// ----------------------------------------------------------------------------

function formValidationResultHandler(forms: TypeFormElementOrList, data: TypeDataConfig = {}): void {
    const elements = Array.isArray(forms) ? forms : [forms];

    for (const elForm of elements) {
        const listener = function (evt: Event): void {
            if (!validateForm(elForm, data)) {
                evt.preventDefault();
            }
        };

        elForm.addEventListener('submit', listener, false);
    }
}

// ----------------------------------------------------------------------------

export default formValidationResultHandler;
